<template>
    <div>
        <div id="carouselExampleCaptions"
             class="carousel slide"
             data-bs-ride="carousel">
            <div class="carousel-indicators" v-if="!isSingle">
                <button type="button"
                        data-bs-target="#carouselExampleCaptions"
                        :data-bs-slide-to="index"
                        :class="index===0?'active':''"
                        :aria-current="index===0?'true':''"
                        :aria-label="'Slide'+ index+1"
                        v-for="(content,index) in data" :key="index"></button>
            </div>
            <div class="carousel-inner">
                <div :class="['carousel-item', (index === 0 ? 'active' : '')]" v-for="(content, index) in data" :key="index">
                    <video v-if="content.VideoURL != ''" class="d-block w-100" autoplay muted loop>
                        <source :src="content.VideoURL" type="video/mp4" />
                    </video>
                    <!-- <img v-bind:src="content.ImageURL" class="d-block w-100" :alt="content.ImageAltText" v-else /> -->
                    <picture v-else>
                        <source media="(min-width:650px)" :srcset="content.ImageURL">
                        <source media="(max-width:649px)" :srcset="content.MobileImageURL">
                        <img v-bind:src="content.ImageURL" class="d-block w-100" :alt="content.ImageAltText">
                    </picture>
                    <div class="hero-carousel-wrapper ">
                        <div class="hero-carousel-title">
                            {{content.Title}}
                        </div>
                        <div class="hero-carousel-description d-none d-md-block">
                            {{content.Description}}
                        </div>
                        <div class="hero-carousel-button-wrapper" v-if="!single">
                            <a aria-label="navigate to respective page" :target="content.GoToLinkTarget" :href="content.GoToURL" class="button-inv">{{content.GoToText}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="prev" v-if="!isSingle">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="next" v-if="!isSingle">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        name: "CarouselBanner",
        components: {},
        props: ["Title", "Description", "src", "srcset", "placeholder", 'data','single'],
        methods: {},
        computed: {
            isSingle() {
                if (this.single === true) {
                    return true;
                }
                return (this.data?.length ?? 0) <= 1;                
            }
        }
    };
</script>